import Link from 'next/link';
import styled from 'styled-components';
import isFunction from 'lodash/isFunction';

interface IGridCellLink {
  'aria-label'?: string;
  children: React.ReactNode;
  onClick?: () => void;
  to: string;
}

export const GridCellLink = ({ 'aria-label': ariaLabel, children, onClick, to }: IGridCellLink) => {
  const handleOnClick = () => {
    if (isFunction(onClick)) {
      onClick();
    }
  };

  return (
    <Link href={to} passHref legacyBehavior>
      <GridCellLink.Link aria-label={ariaLabel || null} onClick={handleOnClick}>
        {children}
      </GridCellLink.Link>
    </Link>
  );
};

GridCellLink.Link = styled.a`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`;
